
import { useState, useId, useEffect } from "react";

import style from '../../Style/Components/fileupload.module.scss';
import { Icon } from "../Other";
import Loader from "../Loader/loader";

const CustomFilePicker = (props) => {
    const [file, setFile] = useState(null);

    const [fileType, setFileType] = useState(null);
    const inputId = useId();

    useEffect(() => {
        if (props.value !== null) {
            setFile(props.value);
        } else {
            setFile(null);
        }
    }, [props.value]);

    const _handleChange = (event, is_clear) => {
        if (is_clear) {
            setFile(null);
            setFileType(null);
            props.handleChange(null);
        } else {
            // const selectedFile = event.target.files[0];
            // const fileURL = URL.createObjectURL(selectedFile);
            // setFile(fileURL);
            // props.handleChange(fileURL);
            const selectedFile = event.target.files[0];
            if (!selectedFile) return;

            // const fileURL = URL.createObjectURL(selectedFile);

            // setFile(fileURL);
            setFileType(selectedFile.type);
            props.handleChange(selectedFile);
        }
    };

    // Trigger file input click
    const triggerFileInput = () => {
        document.getElementById(inputId).click();
    };

    return (
        <div>
            {props.label &&
                <label className={`${style.e_label} pb-2`}>
                    {props.label}
                    {props.required &&
                        <span className="color-carmine-pink">*</span>
                    }
                </label>
            }
            {
                file === null ? (
                    <div className={`${style.file_picker_wrapper} d-flex align-items-center justify-content-center`}
                        onClick={triggerFileInput}>
                        {
                            props.loading ?
                                <Loader width={100}
                                    height={80} />
                                :
                                <>
                                    <div className={style.e_content_wrapper}>
                                        <div className="w-100 d-flex justify-content-center">
                                            <img src={require('../../Assets/document-upload.svg').default} />
                                        </div>
                                        <div className="text-center">
                                            <h6 className="mb-0 mt-2">click to <span>click</span> file to upload</h6>
                                            <p className="mb-0 mt-1">select jpeg, pdf or png</p>
                                        </div>
                                    </div>
                                    {/* Hidden file input */}
                                    <input
                                        id={inputId}
                                        type="file"
                                        className="d-none"
                                        onChange={(e) => _handleChange(e, false)}
                                        maxSize={props.maxSize}
                                        accept={props.accept}
                                    />
                                </>
                        }

                    </div >
                ) : (
                    <div className={`${style.file_picker_wrapper} d-flex align-items-center justify-content-center p-0 position-relative`}>
                        {/* <img src={file} className="w-100 h-100 " /> */}

                        {fileType === 'application/pdf' ? (
                            <iframe src={file} className="w-100 h-100" title="PDF Preview"></iframe>
                        ) : (
                            <img src={file} className="border-radius-16 w-100 h-100 object-fit-contain" alt="Uploaded preview" />
                        )}

                        <Icon icon="close"
                            size={20}
                            className="position-absolute top-8px right-8px z-2 cursor-pointer"
                            onClick={() => _handleChange(null, true)} />
                    </div>
                )
            }
            
            {props.error &&
                <p className={style.e_error_message}>
                    {props.error}
                </p>
            }
           { file === null && <div className={`text-start d-flex align-items-start justify-content-start p-3 e-password-info mb-3 e-font-14 line-height-18px e-primary-font e-font-weight-500 e-text-black ${props.error ? "mt-4" : "mt-3"}`}>
                <span>
                    <svg class="me-1 " width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M53.25 512.042c0-252.34 206.327-458.667 458.667-458.667s458.669 206.327 458.669 458.667c0 252.342-206.33 458.666-458.669 458.666s-458.667-206.323-458.667-458.666zM511.917 117.375c-216.994 0-394.667 177.674-394.667 394.667 0 216.995 177.673 394.666 394.667 394.666 216.992 0 394.669-177.67 394.669-394.666 0-216.993-177.677-394.667-394.669-394.667z" fill="rgb(29, 46, 153)"></path>
                    <path d="M512 309.375c17.673 0 32 14.327 32 32v213.334c0 17.673-14.327 32-32 32s-32-14.327-32-32v-213.334c0-17.673 14.327-32 32-32z" fill="rgb(29, 46, 153)" ></path>
                    <path d="M469.078 682.63c0-23.565 19.102-42.669 42.666-42.669h0.383c23.564 0 42.667 19.105 42.667 42.669 0 23.558-19.103 42.662-42.667 42.662h-0.383c-23.564 0-42.666-19.104-42.666-42.662z" fill="rgb(29, 46, 153)" ></path>
                </svg>
                </span>
                <span>Please upload clear and properly oriented images, without extra space around the image for better visibility.</span>
            </div>}
        </div>

    )
}

export default CustomFilePicker;